import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';

import undergradData from '../resources/json/undergradList.json';
import gradData from '../resources/json/gradList.json';
// import Projects from '../projects/Projects'

import Summary from '../components/summary/Summary';
import CourseTabs from '../components/course/CourseTabs';
import About from '../components/about/About';
import Projects from '../components/projects/Projects';

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
});


class TabContent extends React.Component {

    constructor(props) {
        super(props);
    }


    handleChange = (index) => {
        window.scrollTo(0, 0);
        // this.setState({ value });
        this.props.handleChangeFromContainer(index);
    };


    render() {
        const { classes, theme } = this.props;

        const { value } = this.props;

        return (
            <div className={classes.root} style={{ background: 'transparent' }}>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.props.value}
                    onChangeIndex={this.handleChange}
                    // animateHeight={true}

                >
                    <TabContainer dir={theme.direction}><Summary deviceType={this.props.deviceType}/></TabContainer>
                    <TabContainer dir={theme.direction}><CourseTabs deviceType={this.props.deviceType} coursesJson={undergradData} courseLevel='undergrad'/></TabContainer>
                    <TabContainer dir={theme.direction}><CourseTabs deviceType={this.props.deviceType} coursesJson={gradData} courseLevel='graduate'/></TabContainer>
                    <TabContainer dir={theme.direction}><Projects deviceType={this.props.deviceType} /></TabContainer>
                    <TabContainer dir={theme.direction}><About deviceType={this.props.deviceType}/></TabContainer>
                    {/* <TabContainer dir={theme.direction}><GuestBookTabDesktop /></TabContainer> */}

                </SwipeableViews>
            </div>
        );
    }


}


TabContent.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(TabContent);





// WEBPACK FOOTER //
// ./src/tabs/TabContent.js